import type { ValueOf } from 'type-fest';

export const REOPEN_PETITION_ERROR_MAP = {
	GRAPHQL_ERROR: 'starter_dashboard_reopen_petition_graphql_error',
	NO_DATA_ERROR: 'starter_dashboard_reopen_petition_data_not_found',
	UNAUTHENTICATED_ERROR: 'starter_dashboard_reopen_petition_unauthenticated',
	UNKNOWN_ERROR: 'starter_dashboard_reopen_petition_unknown_error',
} as const;

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const reopenPetitionErrors = Object.values(REOPEN_PETITION_ERROR_MAP) as ReadonlyArray<
	ValueOf<typeof REOPEN_PETITION_ERROR_MAP>
>;

export type ReopenPetitionErrorCodes = (typeof reopenPetitionErrors)[number];
